// App.js
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import Ourcleaning from './components/Our Cleaning/Ourcleaning';
import Book from './components/Book/Book';
import FilteredBook from './components/Book/FilteredBook';

import MapWithCurrentLocation from './components/Book/MapWithCurrentLocation';
import Thanks from './components/Book/Thanks';
// import Colony from './components/Services Area/Colony';
// import Town from './components/Services Area/Town';
// import Ghakhar from './components/Services Area/Ghakhar';
// import Sattelite from './components/Services Area/Sattelite';
import FAQComponent from './components/About/FAQComponent';
import Verify from './components/Client Portal/Verify';
import Feedback from './components/Client Portal/Feedback';
import Blog from './components/About/Blog';
import TermsAndConditions from './components/About/TermsAndConditions';


// In your index.js or App.js
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Login from './components/Client Portal/Login';
import Register from './components/Client Portal/Register';
import Profile from './components/Client Portal/Profile';
import UploadProviderProfileGallery from './components/Client Portal/UploadProviderProfileGallery';
import ViewProviderProfileGallery from './components/Client Portal/ViewProviderProfileGallery'


import OrderHistory from './components/Client Portal/OrderHistory';
import UpdateProfile from './components/Client Portal/UpdateProfile';
import CustomerOrderHistory from './components/Client Portal/CustomerOrderHistory';

import ForgetPassword from './components/Client Portal/ForgetPassword';
import ResetPassword from './components/Client Portal/ResetPassword';
import ChangePassword from './components/Client Portal/ChangePassword';
import Dashboard from './pages/Dashboard';
import MainLayout from './components/MainLayout';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import Employees from './pages/Employees';
import ManageServices from './pages/ManageServices';
import Revenue from './pages/Revenue';
import UserContextProvider from './components/Context/UserContextProvider';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRoute from './components/ProtectedRoute';

import Blind from "./components/Product/Blind";
import Carpet from "./components/Product/Carpet";
import Furniture from "./components/Product/Furniture";
import Sofa from "./components/Product/Sofa";

import Hayes from "./components/Services Area/Hayes";
import Hunslow from "./components/Services Area/Hunslow";
import Southall from "./components/Services Area/Southall";
import Slough from "./components/Services Area/Slough";
import Uxbridge from "./components/Services Area/Uxbridge";
import Greenford from "./components/Services Area/Greenford";
import Northolt from "./components/Services Area/Northolt";
import Windsor from "./components/Services Area/Windsor";
import Ruislip from "./components/Services Area/Ruislip";
import Harrow from "./components/Services Area/Harrow";
import Maidenhead from "./components/Services Area/Maidenhead";
import HighWycombe from "./components/Services Area/HighWycombe";

import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import NotLogin from './pages/NotLogin';
import Contact from './components/About/contact';
import WhatsAppButton from './components/WhatsAppButton';
import RollerBlinds from './components/Product/Blinds/RollerBlinds';
import KitchenBlinds from './components/Product/Blinds/KitchenBlinds';
import VerticalBlinds from './components/Product/Blinds/VerticalBlinds';
import RomanBlinds from './components/Product/Blinds/RomanBlinds';
import WoodenBlinds from './components/Product/Blinds/WoodenBlinds';
import VenetianBlinds from './components/Product/Blinds/VenetianBlinds';
import BlackoutBlinds from './components/Product/Blinds/BlackoutBlinds'; 
import BedroomBlinds from './components/Product/Blinds/BedroomBlinds';
import BathroomBlinds from './components/Product/Blinds/BathroomBlinds';
import LivingRoomBlinds from './components/Product/Blinds/LivingRoomBlinds';
import HowToInstallBlinds from './components/Guides/HowToInstallBlinds';
import HowToCleanBlinds from './components/Guides/HowToCleanBlinds';
import HowToMeasureBlinds from './components/Guides/HowToMeasureBlinds';
import PerfectFitBlinds from './components/Guides/PerfectFitBlinds';

// import { Blinds } from 'lucide-react';

function App() {
  const [role, setRole] = useState("");
  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem("auth"));
    const userRole = authData?.user?.role || "";
    console.log("Role from localStorage:", userRole);
    setRole(userRole);
  }, []);
  // if (!role) {
  //   return <div>Loading...</div>; // or a spinner while role is loading
  // }


  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <UserContextProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Ourcleaning />} />
                <Route path="/login" element={<Login />} />
                {/* <Route path="/feedback" element={<Feedback />} /> */}
                {/* <Route
                   path="/feedback"
        element={
          <ProtectedRoute
            element={<Feedback />}
            allowedRoles={['user']}
            userRole={role}/>
                  }
                /> */}
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<Profile />} />
                <Route
                  path="/gallery/upload/:providerId"
                  element={<UploadProviderProfileGallery />}
                />
                <Route
                  path="/viewGallery/:providerId"
                  element={<ViewProviderProfileGallery />}
                />
                <Route path="/OrderHistory" element={<OrderHistory />} />
                <Route path="/customer-orders" element={<CustomerOrderHistory />} />
                <Route path="/update-profile" element={<UpdateProfile />} />
                <Route path="/forgetpassword" element={<ForgetPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/ChangePassword" element={<ChangePassword />} />
                <Route path="/verify" element={<Verify />} />

                <Route path="/*" element={<NotLogin />} />
                <Route path="/Book" element={<Book />} />
                {/* <Route
    path="/Book"
    element={
      <ProtectedRoute
        element={<Book />}
        allowedRoles={['user']}
        userRole={role}
      />
    }
  /> */}
                <Route path="/FilteredBook" element={<FilteredBook />}></Route>
                {/* <Route
                  path="/FilteredBook" element={
                    <ProtectedRoute  element={<FilteredBook />} allowedRoles={['user']} userRole={role}/>
                  }
                /> */}
                {/* tahir */}
                <Route
                  path="/feedback"
                  element={
                    <ProtectedRoute
                      element={<Feedback />}
                      allowedRoles={['user']}
                      userRole={role}
                    />
                  }
                />

                {/* <Route
                  path="/Book"
                  element={
                    <ProtectedRoute
                      element={<Book />}
                      allowedRoles={['user']}
                      userRole={role}
                    />
                  }
                /> */}

                {/* <Route
                  path="/FilteredBook"
                  element={
                    <ProtectedRoute
                      element={<FilteredBook />}
                      allowedRoles={['user']}
                      userRole={role}
                    />
                  }
                /> */}

                {/* tahir */}
                <Route path="/MapWithCurrentLocation" element={<MapWithCurrentLocation />} />
                <Route path="/thanks" element={<Thanks />} />

                {/* <Route path="/colony" element={<Colony />} />
                <Route path="/Town" element={<Town />} />
                <Route path="/Ghakhar" element={<Ghakhar />} />
                <Route path="/sattelite" element={<Sattelite />} /> */}

                {/* <Route path="/faq" element={<FAQComponent />} /> */}
                <Route path="/faq" element={<FAQComponent />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />

                {/* product */}

                <Route path="/carpets" element={<Carpet />} />
                <Route path="/furniture" element={<Furniture />} />
                {/* <Route path="/bundles" element={<Hunslow />} /> */}
                <Route path="/blinds" element={<Blind />} />
                <Route path="/sofa" element={<Sofa />} />

                {/* cities */}
                <Route path="/hayes" element={<Hayes />} />
                <Route path="/hunslow" element={<Hunslow />} />
                <Route path="/southall" element={<Southall />} />
                <Route path="/slough" element={<Slough />} />
                <Route path="/uxbridge" element={<Uxbridge />} />
                <Route path="/greenford" element={<Greenford />} />
                <Route path="/northolt" element={<Northolt />} />
                <Route path="/windsor" element={<Windsor />} />
                <Route path="/ruislip" element={<Ruislip />} />
                <Route path="/harrow" element={<Harrow />} />
                <Route path="/maidenhead" element={<Maidenhead />} />
                <Route path="/highwycombe" element={<HighWycombe />} />

                {/* Blinds */}
        <Route path="/roller-blinds" element={<RollerBlinds />} />
        <Route path="/vertical-blinds" element={<VerticalBlinds />} />
        <Route path="/roman-blinds" element={<RomanBlinds />} />
        <Route path="/wooden-blinds" element={<WoodenBlinds />} />
        <Route path="/venetian-blinds" element={<VenetianBlinds />} />
        <Route path="/blackout-blinds" element={<BlackoutBlinds />} />

        {/* Rooms */}
        <Route path="/kitchen-blinds" element={<KitchenBlinds />} />
        <Route path="/bedroom-blinds" element={<BedroomBlinds />} />
        <Route path="/bathroom-blinds" element={<BathroomBlinds />} />
        <Route path="/living-room-blinds" element={<LivingRoomBlinds />} />

        {/* Guides */}
        <Route path="/how-to-measure-blinds" element={<HowToMeasureBlinds />} />
        <Route path="/how-to-install-blinds" element={<HowToInstallBlinds />} />
        <Route path="/how-to-clean-blinds" element={<HowToCleanBlinds />} />
         <Route path="/perfect-fit-blinds" element={<PerfectFitBlinds />} />


                {/* Admin Route */}
                <Route path="/admin/*" element={<PrivateRoute requiredRole="admin"> <MainLayout />  </PrivateRoute>}>
                  <Route index element={<Dashboard />} />
                  <Route path="Orders" element={<Orders />} />
                  <Route path="customers" element={<Customers />} />
                  <Route path="Employees" element={<Employees />} />
                  <Route path="ManageServices" element={<ManageServices />} />
                  <Route path="revenue" element={<Revenue />} />
                </Route>
              </Routes>
              <WhatsAppButton />
            </BrowserRouter>
          </UserContextProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;